import { CreateDocumentBundles } from '@repo/document-bundles/CreateDocumentBundles'
import { DocumentBundlesSummary } from '@repo/document-bundles/DocumentBundlesSummary'
import { useDocumentBundleAuthStore } from '@repo/store/useDocumentBundleAuthStore'
import { useDocumentBundleWizardStore } from '@repo/store/useDocumentBundleWizardStore'

export default [
  {
    stageLabel: 'Create Bundle',
    stageId: 'create-bundle',
    resetData: () => {
      useDocumentBundleWizardStore.getState().reset()
      useDocumentBundleAuthStore.getState().reset()
    },
    steps: [
      {
        stepLabel: 'Document bundle details',
        stepDescription: 'Please enter the document bundle details.',
        stepId: 'create-document-bundle',
        skippable: false,
        component: CreateDocumentBundles,
        uniqueId: 'create-document-bundle'
      },
      {
        stepLabel: 'Summary',
        stepDescription: 'summary',
        stepId: 'bundle-summary',
        skippable: false,
        component: DocumentBundlesSummary,
        uniqueId: 'document-bundle-create-bundle'
      }
    ]
  }
]